// data-surface-prefs.ts — localStorage-backed UI preferences for the
// V3 data surface. Per-source so a Stripe webhooks layout doesn't
// bleed onto a Hotel revenue stream. Schema is loose — unknown keys
// are ignored on read. Failures (private mode, quota exceeded)
// silently fall back to defaults.

export interface DataSurfacePrefs {
  showSystemFields?: boolean;
  showSchemaSidebar?: boolean;
  hiddenByTab?: Record<string, string[]>;
  /** Last-active tab name. Operator returns to a curated tab
   *  instead of always the raw `events` view. (audit IA.2) */
  lastActiveTab?: string;
}

export function readPrefs(key: string): DataSurfacePrefs {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (typeof parsed !== 'object' || parsed === null) return {};
    return parsed as DataSurfacePrefs;
  } catch {
    return {};
  }
}

export function writePrefs(key: string, prefs: DataSurfacePrefs): void {
  try { window.localStorage.setItem(key, JSON.stringify(prefs)); } catch { /* private mode / quota */ }
}
